export default "__VITE_ASSET__BnRCcuIs__"